const filters = () => {
  const jsSearch = document.getElementById('search-field');
  const jsSearchTrigger = document.querySelector('.js-search-trigger');
  const jsCategoryDropdown = document.getElementById('category-dropdown');
  const noResultsContainer = document.querySelector('.js-no-results');
  const cards = [...document.querySelectorAll('.col')];
  
  // window.addEventListener('pageshow', () => {
  //   if (jsSearch) filterCards();
  // });
  
  const filterCards = (clicked = false) => {
    let cardsVisible = false;
    const searchValue = jsSearch.value.toLowerCase().trim();
  
    cards.forEach(card => {
      const categoryClasses = Array.from(card.classList).filter(cls => cls.startsWith('js-category-'));
      const selectedCategory = jsCategoryDropdown.value;
    
      // check if the card matches by category
      const cardEqualsCategory = selectedCategory === '' || categoryClasses.some(cls => cls === `js-category-${selectedCategory}`);
    
      // target ingredients attributes for recipes and topic attributes or title for articles
      const dataIngredient = card.querySelector('.card').getAttribute('data-ingredient');
      const dataTopics = [...card.querySelector('.card').attributes].filter(attr => attr.name.startsWith('data-topic-'));
      const searchTitleElement = card.querySelector('.js-search-title');
      const searchTitleText = searchTitleElement ? searchTitleElement.textContent.toLowerCase().trim() : '';
  
      let searchMatch = false;
    
      // if search term then show the corresponding cards
      if (searchValue) {
        // filter recipes by ingredients
        if (dataIngredient) searchMatch = dataIngredient.toLowerCase().includes(searchValue);
        // filter articles by topics
        if (dataTopics.length > 0) searchMatch = searchMatch || dataTopics.some(attr => attr.value.toLowerCase().includes(searchValue));
        // filter articles by title
        if (searchTitleText) searchMatch = searchMatch || searchTitleText.includes(searchValue);
      }
      // else all cards match the search
      else searchMatch = true;
    
      // ensure articles without data attributes do not match when a search term is present
      const hasValidAttributes = dataIngredient || dataTopics.length > 0 || searchTitleText;
      if (searchValue && !hasValidAttributes) searchMatch = false;
  
      if (!searchValue && clicked) searchMatch = false;
    
      // show or hide the card based on filters
      if (searchMatch && cardEqualsCategory) {
        card.style.display = '';
        cardsVisible = true;
      }
      else card.style.display = 'none';
    });
    
  
    // show or hide the no results div
    noResultsContainer.style.display = cardsVisible ? 'none' : 'block';
  };
  
  if (jsSearch) jsSearch.addEventListener('input', () => filterCards(false));
  if (jsSearchTrigger) jsSearchTrigger.addEventListener('click', () => filterCards(true));
  if (jsCategoryDropdown) jsCategoryDropdown.addEventListener('change', () => filterCards(false));
};

export default filters;